import { render, staticRenderFns } from "./teachingStudentDialog.vue?vue&type=template&id=36ac97e1"
import script from "./teachingStudentDialog.vue?vue&type=script&lang=js"
export * from "./teachingStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./teachingStudentDialog.vue?vue&type=style&index=0&id=36ac97e1&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports